var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy-policy__container"},[_c('h3',{staticClass:"header"},[_vm._v("Privacy Policy")])])}]

export { render, staticRenderFns }